/**
 * i18next Configuration
 * Internationalization setup for Polish and Ukrainian languages
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import plTranslation from '@/locales/pl.json';
import uaTranslation from '@/locales/ua.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      pl: {
        translation: plTranslation,
      },
      ua: {
        translation: uaTranslation,
      },
    },
    lng: 'pl', // default language
    fallbackLng: 'pl',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
